import { crudRoutes } from "./routerHelper";

export const routesConfig = [
    // ── Photoshoot image selection (admin marks colour regions on an image) ──
    {
        path: "/photoshoot",
        exact: true,
        permission: "photoshoot:view",
        component: "Photoshoot",
    },
    {
        path: "/photoshoot/add",
        exact: true,
        permission: "photoshoot:create",
        component: "InputPhotoshoot",
    },
    {
        path: "/photoshoot/:id/editor",
        exact: true,
        permission: "photoshoot:update",
        component: "PhotoshootEditor",
    },
    {
        path: "/photoshoot/:id/order",
        exact: true,
        permission: "salesorder:create",
        component: "OrderPhotoshoot",
    },
    // Sample has NO standalone "add" route — samples are created via the design flow
    // (a design that requires sampling). List/details/print are for monitoring/QA.
    { path: "/sample", exact: true, permission: "sample:view", component: "Sample" },
    { path: "/sample/update/:id", exact: true, permission: "sample:update", component: "UpdateSample" },
    { path: "/sample/details/:id", exact: true, permission: "sample:view", component: "DetailsSample" },
    {
        path: "/sample/:id/print",
        exact: true,
        permission: "sample:view",
        component: "PrintSample",
    },
    ...crudRoutes("stockadjustment", "stockadjustment", {
        list: "StockAdjustments",
        add: "InputStockAdjustment",
        update: "UpdateStockAdjustment",
        details: "StockAdjustmentDetail",
    }),
    // Separate ADD and DEDUCT pages
    {
        path: "/stockadjustment/add-stock",
        exact: true,
        permission: "stockadjustment:create",
        component: "AddStockAdjustment",
    },
    {
        path: "/stockadjustment/deduct-stock",
        exact: true,
        permission: "stockadjustment:create",
        component: "DeductStockAdjustment",
    },
    ...crudRoutes("vendorstockadjustment", "vendorstockadjustment", {
        list: "VendorStockAdjustments",
        add: "InputVendorStockAdjustment",
        update: "UpdateVendorStockAdjustment",
        details: "VendorStockAdjustmentDetail",
    }),
    {
        path: "/vendorstockadjustment/add-stock",
        exact: true,
        permission: "vendorstockadjustment:create",
        component: "AddVendorStockAdjustment",
    },
    {
        path: "/vendorstockadjustment/deduct-stock",
        exact: true,
        permission: "vendorstockadjustment:create",
        component: "DeductVendorStockAdjustment",
    },
    {
        path: "/vendorregister",
        exact: true,
        permission: "inwardregister:view",
        component: "VendorRegister",
    },
    ...crudRoutes("internaltransfer", "internaltransfer", {
        list: "InternalTransfers",
        add: "InputInternalTransfer",
        update: "UpdateInternalTransfer",
        details: "InternalTransferDetail",
    }),
    ...crudRoutes("outwardregister", "outwardregister", {
        list: "OutwardRegisters",
        add: "InputOutwardRegister",
        update: "UpdateOutwardRegister",
        details: "OutwardRegisterDetail",
    }),
    { path: "/outwardworktype", exact: true, permission: "outwardworktype:view", component: "OutwardWorkTypes" },
    ...crudRoutes("outwardchallan", "outwardchallan", {
        list: "OutwardChallans",
        add: "InputOutwardChallan",
        update: "UpdateOutwardChallan",
        details: "OutwardChallanDetail",
    }),
    {
        path: "/outwardchallan/:id/print",
        exact: true,
        permission: "outwardchallan:print",
        component: "PrintOutwardChallan",
    },
    // Print route must come BEFORE crudRoutes to avoid /:id path-collision.
    {
        path: "/secondsbatch/:id/print",
        exact: true,
        permission: "secondsbatch:view",
        component: "PrintSecondsBatch",
    },
    ...crudRoutes("secondsbatch", "secondsbatch", {
        list: "SecondsBatchList",
        add: "AddSecondsBatch",
        update: "AddSecondsBatch",
        details: "SecondsBatchDetails",
    }),
    {
        path: "/salesreports/seconds",
        exact: true,
        permission: "reports:seconds",
        component: "SecondsReport",
    },
    ...crudRoutes("inwardregister", "inwardregister", {
        list: "InwardRegisters",
        add: "InputInwardRegister",
        update: "UpdateInwardRegister",
        details: "InwardRegisterDetail",
    }),
    ...crudRoutes("quality", "quality", {
        list: "ApprovedQuality",
        add: "InputQuality",
        update: "UpdateQuality",
        details: "DetailsQuality",
    }),
    ...crudRoutes("yarnshade", "yarnshade", {
        list: "YarnShade",
        add: "InputYarnShade",
        details: null, // No details page
    }),
    ...crudRoutes("matchingcode", "matchingcode", {
        list: "MatchingCode",
        add: "InputMatchingCode",
        update: "UpdateMatchingCode",
        details: null,
    }),
    ...crudRoutes("warpbeam", "warpbeam", {
        list: "Warpbeam",
        add: "InputWarpbeam",
        update: "UpdateWarpbeam",
        details: "DetailsWarpbeam",
    }),
    {
        path: "/warpbeam/print/:id",
        exact: true,
        permission: "warpbeam:view",
        component: "PrintWarpbeam",
    },
    ...crudRoutes("yarnquality", "yarnquality", {
        list: "YarnQuality",
        add: "InputYarnQuality",
        update: "UpdateYarnQuality",
        details: null,
    }),
    ...crudRoutes("sareecategory", "sareecategory", {
        list: "SareeCategory",
        add: "InputSareeCategory",
        update: "UpdateSareeCategory",
        details: null,
    }),
    ...crudRoutes("valueaddition", "valueaddition", {
        list: "ValueAddition",
        add: "InputValueAddition",
        update: "UpdateValueAddition",
        details: null,
    }),
    ...crudRoutes("bank", "bank", {
        list: "Bank",
        add: "InputBank",
        update: "UpdateBank",
        details: null,
    }),
    ...crudRoutes("catalogue", "catalogue", {
        list: "Catalogue",
        add: "InputCatalogue",
        update: "UpdateCatalogue",
        details: "DetailsCatalogue",
    }),
    {
        path: "/catalogue/bulk-update",
        exact: true,
        permission: "catalogue:bulk_update",
        component: "BulkUpdateCatalogue",
    },
    // Amend route must come BEFORE crudRoutes to avoid path-collision with /:id
    {
        path: "/settemplate/amend/:id",
        exact: true,
        permission: "templateset:update",
        component: "AmendSetTemplate",
    },
    ...crudRoutes("settemplate", "templateset", {
        list: "SetTemplateList",
        add: "InputSetTemplate",
        update: "InputSetTemplate",
        details: "DetailsSetTemplate",
    }),
    // Amend route must come BEFORE crudRoutes to avoid path-collision with /:id
    {
        path: "/salesset/amend/:id",
        exact: true,
        permission: "salesset:amend",
        component: "AmendSalesSet",
    },
    ...crudRoutes("salesset", "salesset", {
        list: "SalesSetList",
        add: "InputSalesSet",
        update: "InputSalesSet",
        details: null,
    }),
    ...crudRoutes("cataloguematching", "cataloguematching", {
        list: "CatalogueMatching",
        add: "InputCatalogueMatching",
        update: "UpdateCatalogueMatching",
        details: "DetailsCatalogueMatching",
    }),
    {
        path: "/cataloguematching/approvals",
        exact: true,
        permission: ["cataloguematching:update", "cataloguematching:approve"],
        component: "CatalogueMatchingApprovals",
    },
    ...crudRoutes("cataloguesalecolours", "cataloguesalescolour", {
        list: "CatalogueSaleColours",
        add: "InputCatalogueSaleColour",
        update: "UpdateCatalogueSaleColour",
        details: "DetailsCatalogueSaleColour",
    }),
    {
        path: "/cataloguedescription",
        exact: true,
        permission: "cataloguedescription:view",
        component: "CatalogueDescription",
    },
    {
        path: "/cataloguedescription/add",
        exact: true,
        permission: "cataloguedescription:update",
        component: "InputCatalogueDescription",
    },
    // Before crudRoutes so "/party/bulk-contacts" isn't read as "/party/:id".
    {
        path: "/party/bulk-contacts",
        exact: true,
        permission: "party:update",
        component: "BulkPartyContacts",
    },
    ...crudRoutes("party", "party", {
        list: "Party",
        add: "InputParty",
        update: "UpdateParty",
        details: "PartyDetail",
        // Details page has its own permission (party:update implies it).
        detailsPermission: ["party:details", "party:update"],
    }),
    {
        path: "/pendingparty",
        exact: true,
        permission: "party:view",
        component: "PendingParty",
    },
    {
        path: "/pendingparty/add/:id",
        exact: true,
        permission: "party:create",
        component: "AddPendingParty",
    },
    ...crudRoutes("transport", "transport", {
        list: "Transport",
        add: "InputTransport",
        update: "UpdateTransport",
        details: null,
    }),
    ...crudRoutes("firm", "firm", {
        list: "Firm",
        add: "InputFirm",
        update: "UpdateFirm",
        details: null,
    }),
    {
        path: "/businessunit",
        component: "BusinessUnit",
        permission: "businessunit:view",
    },
    ...crudRoutes("paymentvoucher", "payment_voucher", {
        list: "PaymentVoucherList",
        add: "InputPaymentVoucher",
        update: "UpdatePaymentVoucher",
        details: "PaymentVoucherDetail",
    }),
    {
        path: "/paymentvoucher/suspended",
        component: "SuspendedVouchers",
        permission: "payment_voucher:view",
    },
    {
        path: "/paymentvoucher/:id/print",
        component: "PrintPaymentVoucher",
        permission: "payment_voucher:view",
    },
    {
        path: "/paymentvoucher/:id/reconcile",
        component: "ReconcilePaymentVoucher",
        permission: "payment_voucher:create",
    },
    // Journal vouchers (manual & inter-firm ledger entries)
    { path: "/journalvoucher", exact: true, permission: "journal_voucher:view", component: "JournalVoucherList" },
    { path: "/journalvoucher/add", exact: true, permission: "journal_voucher:create", component: "InputJournalVoucher" },
    { path: "/journalvoucher/edit/:id", exact: true, permission: "journal_voucher:manage", component: "InputJournalVoucher" },
    { path: "/journalvoucher/details/:id", exact: true, permission: "journal_voucher:view", component: "JournalVoucherDetails" },
    { path: "/journalvoucher/:id/print", exact: true, permission: "journal_voucher:view", component: "PrintJournalVoucher" },
    { path: "/accountreports/balance-confirmations", exact: true, permission: "accounts:balance_confirmation", component: "BalanceConfirmations" },
    { path: "/ledger-accounts", exact: true, permission: "ledger_account:view", component: "LedgerAccounts" },
    ...crudRoutes("creditnote", "creditnote", {
        list: "CreditNoteList",
        add: "InputCreditNote",
        update: "UpdateCreditNote",
        details: "CreditNoteDetail",
    }),
    // Print / preview a single credit note (standalone or GR-linked) as PDF.
    { path: "/creditnote/:id/print", exact: true, permission: "creditnote:view", component: "PrintCreditNote" },
    ...crudRoutes("debitnote", "debitnote", {
        list: "DebitNoteList",
        add: "InputDebitNote",
        update: null,
        details: "DebitNoteDetail",
    }),
    { path: "/debitnote/:id/print", exact: true, permission: "debitnote:view", component: "PrintDebitNote" },
    ...crudRoutes("salesman", "salesman", {
        list: "Salesman",
        add: "InputSalesman",
        update: "UpdateSalesman",
        details: null,
    }),
    ...crudRoutes("agent", "agent", {
        list: "Agent",
        add: "InputAgent",
        update: "UpdateAgent",
        details: null,
    }),
    ...crudRoutes("design", "design", {
        list: "Design",
        add: "InputDesign",
        update: "UpdateDesign",
        details: "DetailsDesign",
        detailsPermission: "design:details",
    }),
    {
        path: "/design/approvals",
        exact: true,
        permission: ["design:update", "design:approve"],
        component: "DesignApprovals",
    },
    {
        path: "/design/bulk-update",
        exact: true,
        permission: "design:update",
        component: "BulkUpdateDesigns",
    },
    ...crudRoutes("harness", "harness", {
        list: "Harness",
        add: "InputHarness",
        update: "UpdateHarness",
        details: null,
    }),
    ...crudRoutes("hsncode", "hsncode", {
        list: "HsnCode",
        add: "InputHsnCode",
        update: "UpdateHsnCode",
        details: null,
    }),
    ...crudRoutes("machine", "machine", {
        list: "Machine",
        add: "InputMachine",
        update: "UpdateMachine",
        details: "MachineDetails",
    }),
    ...crudRoutes("loomshade", "loomshade", {
        list: "LoomShade",
        add: "InputLoomShade",
        update: "UpdateLoomShade",
    }),
    ...crudRoutes("operator", "operator", {
        list: "Operator",
        add: "InputOperator",
        update: "UpdateOperator",
    }),
    ...crudRoutes("purchaseorder", "purchaseorder", {
        list: "PurchaseOrder",
        add: "InputPurchaseOrder",
        update: "UpdatePurchaseOrder",
        details: "DetailPurchaseOrder",
    }),
    // ── Peta Order ──────────────────────────────────────────────────────────
    {
        path: "/petaorder",
        exact: true,
        permission: "petaorder:view",
        component: "PetaOrder",
    },
    {
        path: "/petaorder/add",
        exact: true,
        permission: "petaorder:create",
        component: "InputPetaOrder",
    },
    {
        path: "/petaorder/update/:id",
        exact: true,
        permission: "petaorder:update",
        component: "UpdatePetaOrder",
    },
    {
        path: "/petaorder/details/:id",
        exact: true,
        permission: "petaorder:view",
        component: "DetailPetaOrder",
    },
    {
        path: "/purchasechallan/add/from-order/:orderid",
        exact: true,
        permission: "purchasechallan:create",
        component: "InputPurchaseChallan",
    },
    ...crudRoutes("purchasechallan", "purchasechallan", {
        list: "PurchaseChallan",
        add: "InputPurchaseChallan",
        update: "UpdatePurchaseChallan",
        details: "PurchaseChallanDetails",
    }),
    // ── Purchase Bill ──────────────────────────────────────────────────────────
    {
        path: "/purchasebill",
        exact: true,
        permission: "purchasebill:view",
        component: "PurchaseBill",
    },
    {
        path: "/purchasebill/add",
        exact: true,
        permission: "purchasebill:create",
        component: "InputPurchaseBill",
    },
    {
        path: "/purchasebill/verify/:draftId",
        exact: true,
        permission: "purchasebill:create",
        component: "VerifyPurchaseBillDraft",
    },
    {
        path: "/purchasebill/combine",
        exact: true,
        permission: "purchasebill:create",
        component: "CombinePurchaseBill",
    },
    {
        path: "/purchasebill/update/:id",
        exact: true,
        permission: "purchasebill:update",
        component: "UpdatePurchaseBill",
    },
    {
        path: "/purchasebill/details/:id",
        exact: true,
        permission: "purchasebill:view",
        component: "PurchaseBillDetail",
    },
    {
        path: "/purchasebill/:id/print",
        exact: true,
        permission: "purchasebill:view",
        component: "PrintPurchaseBill",
    },
    ...crudRoutes("users", "users", {
        list: "User",
        add: "InputUser",
        update: "UpdateUser",
        details: "UserPermissions",
    }),
    ...crudRoutes("roles", "roles", {
        list: "Role",
        add: "InputRole",
        update: "UpdateRole",
        details: "RoleDetails",
    }),
    ...crudRoutes("accessmodule", "accessmodule", {
        list: "AccessModule",
        add: "InputAccessModule",
        update: "UpdateAccessModule",
        details: "AccessModuleDetails",
    }),
    ...crudRoutes("warppattern", "warppattern", {
        list: "WarpPattern",
        add: "InputWarpPattern",
        update: "UpdateWarpPattern",
        details: null,
    }),
    ...crudRoutes("warpdesigncolour", "warpdesigncolour", {
        list: "WarpDesignColour",
        add: "InputWarpDesignColour",
        update: "UpdateWarpDesignColour",
        details: null,
    }),
    // Amend route must come BEFORE crudRoutes to avoid path-collision with /:id
    {
        path: "/salesorder/amend/:id",
        exact: true,
        permission: "salesorder:amend",
        component: "AmendSalesOrder",
    },
    ...crudRoutes("salesorder", "salesorder", {
        list: "SalesOrder",
        add: "InputSalesOrder",
        update: "UpdateSalesOrder",
        details: "SalesOrderDetail",
    }),
    ...crudRoutes("matching", "matching", {
        list: "DesignMatching",
        add: "InputMatching",
        update: "UpdateMatching",
        details: "SingleMatching",
    }),
    {
        path: "/matching/approvals",
        exact: true,
        permission: ["matching:update", "matching:approve"],
        component: "MatchingApprovals",
    },
    {
        path: "/matching/bulk-update",
        exact: true,
        permission: "matching:update",
        component: "BulkUpdateMatchings",
    },
    ...crudRoutes("orderbook", "orderbook", {
        list: "Orderbooks",
        add: "InputOrderbook",
        update: "UpdateOrderbook",
        details: "OrderbookDetails",
    }),
    ...crudRoutes("location", "location", {
        list: "Location",
        add: "InputLocation",
        update: "UpdateLocation",
        details: "DetailsLocation",
    }),
    ...crudRoutes("stitchtemplate", "stitchtemplate", {
        list: "StitchTemplates",
        add: "InputStitchTemplate",
        update: "UpdateStitchTemplate",
        details: "StitchTemplateDetail",
    }),
    ...crudRoutes("lehengarecipe", "lehengarecipe", {
        list: "ProcessingRecipes",
        add: "InputProcessingRecipe",
        update: "UpdateProcessingRecipe",
        details: "ProcessingRecipeDetail",
    }),
    ...crudRoutes("dyeingrecipe", "dyeingrecipe", {
        list: "DyeingRecipes",
        add: "InputDyeingRecipe",
        update: "UpdateDyeingRecipe",
        details: "DyeingRecipeDetail",
    }),
];

export const specialRoutesConfig = [
    {
        path: "/",
        component: "Home",
        permission: "",
    },
    {
        path: "/dashboard",
        component: "Dashboard",
        permission: "dashboard:view",
    },
    {
        path: "/machineprogram/bulk-close/history",
        component: "BulkCloseMachineProgramHistory",
        permission: "machineprogram:bulkclose",
    },
    {
        path: "/machineprogram/bulk-close",
        component: "BulkCloseMachineProgram",
        permission: "machineprogram:bulkclose",
    },
    {
        path: "/machineprogram/run-selection/add",
        component: "MachineProgramRunSelection",
        permission: "runselection:save",
    },
    {
        path: "/machineprogram/run-selection/:id/print",
        component: "MachineProgramRunSelectionPrint",
        permission: "runselection:view",
    },
    {
        path: "/machineprogram/run-selection",
        component: "MachineProgramRunSelectionList",
        permission: "runselection:view",
    },
    {
        path: "/machineprogram/add/bulk",
        component: "BulkAddMachineProgram",
        permission: "machineprogram:create",
    },
    {
        path: "/machineprogram/add/orderdirect",
        component: "InputMachineProgramOrderDirect",
        permission: "machineprogram:create",
    },
    {
        path: "/machineprogram/add",
        component: "InputMachineProgram",
        permission: "machineprogram:create",
    },
    {
        path: "/machineprogram",
        component: "MachineProgram",
        permission: "machineprogram:view",
    },
    {
        path: "/machineprogram/add/order/:orderid",
        component: "InputMachineProgramOrderDirect",
        permission: "machineprogram:create",
    },
    {
        path: "/machineprogram/machineno/:machineno/programid/:programid/print",
        component: "PrintSingleMachineProgram",
        permission: "machineprogram:print",
    },
    {
        path: "/machineprogram/machine/:machineno/print",
        component: "PrintMachineProgram",
        permission: "machineprogram:print",
    },
    {
        path: "/machineprogram/summary/:machineno/print",
        component: "PrintSummaryMachineProgram",
        permission: "machineprogram:print",
    },
    {
        path: "/yarnshade/update",
        component: "UpdateYarnShade",
        permission: "yarnshade:update",
    },
    // DESIGN special
    {
        path: "/design/add/similar/:id",
        component: "AddSimilarDesign",
        permission: "design:create",
    },

    // DESIGN COSTING
    {
        path: "/design/cost",
        component: "CostDesign",
        permission: "designcosting:view",
    },
    {
        path: "/design/cost/add",
        component: "InputCostDesign",
        permission: "designcosting:create",
    },
    {
        path: "/design/details/cost/:id",
        component: "DetailsCostDesign",
        permission: "designcosting:view",
    },
    {
        path: "/design/cost/add/similar/:id",
        component: "AddSimilarCostDesign",
        permission: "designcosting:create",
    },
    {
        path: "/design/cost/update/:id",
        component: "UpdateCostDesign",
        permission: "designcosting:update",
    },

    // SALES ORDER (special)
    {
        path: "/salesorder/pending-by-party",
        component: "PendingDesignsByParty",
        permission: "salesorder:view",
    },
    {
        path: "/salesorder/pending-by-catalogue",
        component: "PendingDesignsByCatalogue",
        permission: "salesorder:view",
    },
    {
        path: "/salesorder/ready-to-dispatch",
        component: "ReadyToDispatch",
        permission: "salesorder:view",
    },
    {
        path: "/salesorder/pick-list",
        component: "PickListByRack",
        permission: "salesorder:view",
    },
    // ── Racks (master = rack:*, catalogues on racks = rackallocation:*) ──
    {
        path: "/rack",
        exact: true,
        component: "Racks",
        permission: ["rack:view", "rackallocation:view", "rackallocation:update"],
    },
    {
        path: "/rack/view/:id",
        exact: true,
        component: "RackDetail",
        permission: ["rack:view", "rackallocation:view", "rackallocation:update"],
    },
    {
        path: "/salesorders/pending",
        component: "PendingSalesOrders",
        permission: "salesorder:view",
    },
    {
        path: "/salesorders/closed",
        component: "ClosedSalesOrders",
        permission: "salesorder:view",
    },
    {
        path: "/salesorder/:orderid/print",
        component: "PrintSalesOrder",
        permission: "salesorder:print",
    },
    {
        path: "/salesorder/:orderid/pending-print",
        component: "PrintPendingSaree",
        permission: "salesorder:print",
    },
    {
        path: "/salesorder/party/:partyId/pending-print",
        component: "PrintPartyPendingSaree",
        permission: "salesorder:print",
    },
    {
        path: "/salesorder/bulk-actions",
        component: "SalesOrderBulkActions",
        permission: "salesorder:view",
    },
    {
        path: "/salesorder/bulk-print-pending",
        component: "BulkPrintPendingSalesOrder",
        permission: "salesorder:print",
    },
    // PRODUCTION ORDER
    {
        path: "/productionorder/bulk-cancel/history",
        component: "BulkCancelProductionOrderHistory",
        permission: "productionorder:bulkcancel",
    },
    {
        path: "/productionorder/bulk-cancel",
        component: "BulkCancelProductionOrder",
        permission: "productionorder:bulkcancel",
    },
    {
        path: "/productionorder/bulk-print",
        component: "BulkPrintProductionOrder",
        permission: "productionorder:print",
    },
    {
        path: "/productionorders",
        component: "ProductionOrders",
        permission: "productionorder:view",
    },
    {
        path: "/productionorders/completed",
        component: "CompletedProductionOrders",
        permission: "productionorder:producedreport",
    },
    {
        path: "/productionorder/add",
        component: "InputProductionOrder",
        permission: "productionorder:create",
    },
    // Specific ungraded-inventory routes MUST precede the "/:orderid/print"
    // param route below, or the Switch would treat "ungraded-inventory" as an orderid.
    {
        path: "/productionorder/ungraded-inventory/print",
        component: "PrintUngradedGradingSheet",
        permission: "productionorder:grade",
    },
    {
        path: "/productionorder/ungraded-inventory",
        component: "UngradedInventory",
        permission: "productionorder:grade",
    },
    {
        path: "/productionorder/:orderid/print",
        component: "PrintProductionOrder",
        permission: "productionorder:print",
    },
    {
        path: "/productionorder/production-complete/:orderid",
        component: "ProductionCompletedForm",
        permission: "productionorder:close",
    },
    {
        path: "/productionorder/grade/:orderid",
        component: "GradeProductionOrder",
        permission: "productionorder:grade",
    },
    {
        path: "/productionorder/close/update/:orderid",
        component: "UpdateCloseProductionOrder",
        permission: "productionorder:updateclose",
    },
    {
        path: "/productionorder/close/:orderid",
        component: "CloseProductionOrder",
        permission: "productionorder:close",
    },
    {
        path: "/productionorder/update/:orderid",
        component: "UpdateProductionOrder",
        permission: "productionorder:update",
    },
    {
        path: "/productionorder/detail/:orderid",
        component: "ProductionOrderDetail",
        permission: "productionorder:view",
    },

    // YARN PRICE
    {
        path: "/yarn/price",
        component: "YarnPrice",
        permission: "yarnprice:view",
    },
    {
        path: "/yarnprice/update/:partyid",
        component: "UpdateYarnPrice",
        permission: "yarnprice:update",
    },

    // ─── YARN INVENTORY (new) ──────────────────────────────────────────────────
    {
        path: "/yarn-inventory/cartoons",
        component: "CartoonList",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/stock",
        component: "YarnInventoryStock",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/available-stock",
        component: "YarnInventoryAvailableStock",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/receipt/add",
        component: "RegisterYarnReceipt",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/pending-approvals",
        component: "YarnInventoryPendingApprovals",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/transfer/add",
        component: "InputYarnTransfer",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/transfer/:transfer_id",
        component: "YarnTransferDetail",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/consumption/add",
        component: "InputYarnConsumption",
        permission: "yarn_consumption:create",
    },
    {
        path: "/yarn-inventory/consumption/add-by-cartoon",
        component: "InputYarnConsumptionByCartoon",
        permission: "yarn_consumption:create",
    },
    {
        path: "/yarn-inventory/cartoon/scan/:cartoonno?",
        component: "ScanCartoon",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/cartoon-labels/print",
        component: "PrintCartoonLabels",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/consumption/details/:consumption_id",
        component: "YarnConsumptionDetails",
        permission: "yarn_consumption:view",
    },
    {
        path: "/yarn-inventory/consumption/update/:consumption_id",
        component: "UpdateYarnConsumption",
        permission: "yarn_consumption:update",
    },
    {
        path: "/yarn-inventory/consumption",
        component: "YarnConsumptionList",
        permission: "yarn_consumption:view",
    },
    // ── Yarn Adjustment ──────────────────────────────────────────────────────
    {
        path: "/yarn-inventory/adjustment/add",
        component: "BulkAddCartoon",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/adjustment/consume",
        component: "BulkConsumeCartoon",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/adjustment/delete",
        component: "BulkDeleteCartoon",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/adjustment/:id/print",
        component: "PrintYarnAdjustment",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/adjustment/:id",
        component: "YarnAdjustmentDetail",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/adjustment",
        component: "YarnAdjustmentList",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/supplier-return/add",
        component: "InputSupplierReturn",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/sale/add",
        component: "InputYarnSale",
        permission: "yarn_inventory:create",
    },
    {
        path: "/yarn-inventory/cartoon/:cartoon_id/audit",
        component: "CartoonAuditTrail",
        permission: "yarn_inventory:view",
    },
    {
        path: "/cartoonlocationaudit/add",
        component: "InputCartoonLocationAudit",
        permission: "cartoon:mark-inactive",
    },
    {
        path: "/cartoonqualityshadeaudit/add",
        component: "CartoonQualityShadeAudit",
        permission: "cartoon:mark-inactive",
    },

    // ─── YARN INVENTORY REPORTS ─────────────────────────────────────────────────
    {
        path: "/yarn-inventory/reports/shade-summary",
        component: "YarnShadeSummary",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/reports/weekly-consumption",
        component: "WeeklyConsumptionReport",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/reports/monthly-purchases",
        component: "MonthlyPurchaseReport",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/reports/movement",
        component: "YarnMovementReport",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/reports/shade-consumption/:qualityid/:shadeno",
        component: "ShadeConsumptionDetail",
        permission: "yarn_inventory:view",
    },

    // ─── YARN CARTON STOCK MODE (YARN_CARTON_MODE_ENABLED) ───────────────────────
    {
        path: "/yarn-inventory/carton-defaults",
        component: "YarnCartonDefaults",
        permission: "yarn_carton:adjust",
    },
    {
        path: "/yarn-inventory/carton-stock",
        component: "YarnCartonStock",
        permission: "yarn_inventory:view",
    },
    {
        // Company/manufacturer-wise carton stock (Workstream C)
        path: "/yarn-inventory/stock/by-manufacturer",
        component: "YarnStockByManufacturer",
        permission: "yarn_inventory:view",
    },
    {
        // Read-only stock drift diagnostics (Workstream D)
        path: "/yarn-inventory/reports/reconciliation",
        component: "YarnStockReconciliation",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/reports/carton-day-summary",
        component: "YarnCartonDaySummary",
        permission: "reports:yarncartonstock",
    },
    {
        path: "/yarn-inventory/reports/carton-stock/print",
        component: "PrintYarnCartonStock",
        permission: "reports:yarncartonstock",
    },
    {
        path: "/yarn-inventory/reports/carton-day-summary/print",
        component: "PrintYarnCartonDaySummary",
        permission: "reports:yarncartonstock",
    },
    {
        path: "/yarn-inventory/carton-consumption/add",
        component: "InputYarnCartonConsumption",
        permission: "yarn_consumption:create",
    },
    {
        path: "/yarn-inventory/carton-consumption/sheet",
        component: "InputYarnCartonConsumptionSheet",
        permission: "yarn_consumption:create",
    },
    {
        path: "/yarn-inventory/carton-consumption/update/:entry_id",
        component: "InputYarnCartonConsumption",
        permission: "yarn_carton:update",
    },
    {
        path: "/yarn-inventory/carton-consumption/details/:entry_id",
        component: "YarnCartonConsumptionDetail",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/carton-consumption",
        component: "YarnCartonConsumptionList",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/carton-adjustment/add",
        component: "InputYarnCartonAdjustment",
        permission: "yarn_carton:adjust",
    },
    {
        path: "/yarn-inventory/carton-adjustment/update/:entry_id",
        component: "InputYarnCartonAdjustment",
        permission: "yarn_carton:update",
    },
    {
        path: "/yarn-inventory/carton-adjustment/details/:entry_id",
        component: "YarnCartonAdjustmentDetail",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/carton-adjustment",
        component: "YarnCartonAdjustmentList",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/carton-reorder",
        component: "YarnCartonReorder",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/run-rate",
        component: "YarnRunRate",
        permission: "yarn_inventory:view",
    },
    {
        path: "/yarn-inventory/shade-sequence",
        component: "YarnShadeSequence",
        permission: "yarnshade:sequence",
    },

    // SALES BILL
    {
        path: "/salesbill/add",
        component: "InputSalesBill",
        permission: "salesbill:create",
    },
    {
        path: "/salesbill/bulk-print",
        component: "BulkPrintSalesBill",
        permission: "salesbill:print",
    },
    {
        path: "/salesbill/bulk-eway",
        component: "BulkEwaySalesBill",
        permission: "salesbill:eway_bulk",
    },
    {
        path: "/salesbill/transport-receipts",
        component: "TransportReceipts",
        permission: ["salesbill:transport_receipt", "salesbill:transport_receipt_update", "salesbill:transport_receipt_approve", "salesbill:transport_receipt_not_required"],
    },
    {
        path: "/salesbill/detail/:invoiceid",
        component: "SalesBillDetail",
        permission: "salesbill:view",
    },
    {
        path: "/salesbill/update/:id",
        component: "UpdateSalesBill",
        permission: "salesbill:update",
    },
    {
        path: "/salesbill/:invoiceid/print",
        component: "PrintSalesBill",
        permission: "salesbill:print",
    },
    {
        path: "/salesbill",
        component: "SalesBill",
        permission: "salesbill:view",
    },

    // SALES CHALLAN
    {
        path: "/saleschallan/add",
        component: "InputSalesChallan",
        permission: "saleschallan:create",
    },
    {
        path: "/saleschallan/bulk-print",
        component: "BulkPrintSalesChallan",
        permission: "saleschallan:print",
    },
    {
        path: "/saleschallan",
        component: "SalesChallan",
        permission: "saleschallan:view",
    },
    {
        path: "/saleschallan/detail/:challanid",
        component: "SalesChallanDetail",
        permission: "saleschallan:view",
    },
    {
        path: "/saleschallan/update/:challanid",
        component: "UpdateSalesChallan",
        permission: "saleschallan:update",
    },
    {
        path: "/saleschallan/:challanid/print",
        component: "PrintSalesChallan",
        permission: "saleschallan:print",
    },

    // SALES RETURN (QR Goods Return)
    {
        path: "/salesreturn/add",
        component: "InputSalesReturn",
        permission: "salesreturn:create",
    },
    {
        path: "/salesreturn/update/:returnid",
        component: "UpdateSalesReturn",
        permission: "salesreturn:create",
    },
    {
        path: "/salesreturn/amend/:returnid",
        component: "AmendSalesReturn",
        permission: "salesreturn:amend",
    },
    {
        path: "/salesreturn/bulk-print",
        component: "BulkPrintSalesReturn",
        permission: "salesreturn:print",
    },
    {
        path: "/salesreturn/party-grnotes",
        component: "PartyGrNotes",
        permission: ["salesreturn:grnote", "salesreturn:grnote_update", "salesreturn:grnote_approve", "salesreturn:grnote_not_required"],
    },
    {
        path: "/salesreturn/approvals",
        component: "SalesReturnApprovals",
        permission: "salesreturn:approve",
    },
    {
        // Consolidated pending-approvals hub. Intentionally ungated at the route
        // level — the page self-gates each section by its own `:approve` permission
        // and shows an empty state when the user can approve nothing.
        path: "/approvals",
        component: "PendingApprovals",
    },
    {
        path: "/salesreturn/:returnid/labels",
        component: "PrintSalesReturnLabels",
        permission: "salesreturn:print",
    },
    {
        path: "/salesreturn/:returnid/print",
        component: "PrintSalesReturn",
        permission: "salesreturn:print",
    },
    {
        path: "/salesreturn/:returnid",
        component: "SalesReturnDetail",
        permission: "salesreturn:view",
    },
    {
        path: "/salesreturn",
        component: "SalesReturn",
        permission: "salesreturn:view",
    },
    // MACHINE PROGRAM special
    {
        path: "/machineprogram/:programid/print",
        component: "PrintMachineProgram",
        permission: "machineprogram:print",
    },
    {
        path: "/machineprogram/:programid/summary/print",
        component: "PrintSummaryMachineProgram",
        permission: "machineprogram:print",
    },
    {
        path: "/machineprogram/transfer",
        component: "TransferMachineProgram",
        permission: "machineprogram:transfer",
    },
    {
        path: "/machineprogram/transfer/multiple",
        component: "TransferMultipleMachineProgram",
        permission: "machineprogram:transfer",
    },
    {
        path: "/machineprogram/close",
        component: "CloseMachineProgram",
        permission: "machineprogram:close",
    },
    {
        path: "/machineprogram/roll-completion",
        component: "ClothRollCompletion",
        permission: "machineprogram:rollcomplete",
    },
    {
        path: "/machineprogram/roll-completion-list",
        component: "ClothRollCompletionList",
        permission: "machineprogram:rollcomplete",
    },

    {
        path: "/machineprogram/po/:orderid/print",
        component: "PrintPOMachineProgram",
        permission: "machineprogram:print",
    },
    {
        path: "/internaltransfer/:id/print",
        component: "PrintInternalTransfer",
        permission: "internaltransfer:print",
    },
    {
        path: "/internaltransfer/bulk-print",
        component: "BulkPrintInternalTransfer",
        permission: "internaltransfer:print",
    },
    {
        path: "/outwardregister/deliveries",
        exact: true,
        component: "OutwardRegisterDeliveries",
        permission: "outwardregister:approve",
    },
    {
        path: "/outwardregister/delivery-report",
        exact: true,
        component: "DeliveryReport",
        permission: "outwardregister:view",
    },
    {
        path: "/outwardregister/bulk-eway",
        component: "BulkEwayJobWork",
        permission: "outwardregister:eway_bulk",
    },
    {
        path: "/outwardregister/bulk-print",
        component: "BulkPrintOutwardRegister",
        permission: "outwardregister:print",
    },
    {
        path: "/outwardregister/:id/print",
        component: "PrintOutwardRegister",
        permission: "outwardregister:print",
    },
    {
        path: "/inwardregister/report",
        exact: true,
        component: "InwardReport",
        permission: "inwardregister:view",
    },
    {
        path: "/inwardregister/:id/print",
        component: "PrintInwardRegister",
        permission: "inwardregister:print",
    },
    {
        path: "/inwardregister/bulk-print",
        component: "BulkPrintInwardRegister",
        permission: "inwardregister:print",
    },
    {
        path: "/internaltransfer/add/po/:poid?",
        component: "InputInternalTransferFromPO",
        permission: "internaltransfer:create",
    },
    {
        path: "/outwardregister/add/from-register",
        component: "InputOutwardRegisterFromRegister",
        permission: "outwardregister:create",
    },
    {
        path: "/outwardregister/add/multi-po",
        component: "InputOutwardRegisterMultiPO",
        permission: "outwardregister:create",
    },
    {
        path: "/outwardregister/add/po/:poid?",
        component: "InputOutwardRegisterFromPO",
        permission: "outwardregister:create",
    },
    {
        path: "/inwardregister/add/outward/:outwardId?",
        component: "InputInwardRegisterFromOutward",
        permission: "inwardregister:create",
    },
    {
        path: "/productionorder/add/orderbook/:obId",
        component: "InputProductionOrder",
        permission: "productionorder:create",
    },
    {
        path: "/yarnshade/bulkupdate",
        component: "BulkUpdateYarnShade",
        permission: "yarnshade:update",
    },
    {
        path: "/quality/all",
        component: "Quality",
        permission: "quality:viewall",
    },
    {
        path: "/purchaseorder/:id/print",
        component: "PrintPurchaseOrder",
        permission: "purchaseorder:print",
    },
    {
        path: "/purchasechallan/:challanid/print",
        component: "PrintPurchaseChallan",
        permission: "purchasechallan:view",
    },

    // ─── UNIT QR ──────────────────────────────────────────────────────
    { path: "/unitqr/generate",           component: "GenerateQR",              permission: "unitqr:create" },
    { path: "/unitqr/scan/:qr?",          component: "ScanQR",                  permission: "unitqr:view"   },
    { path: "/unitqr/print",              component: "PrintUnitQR",             permission: "unitqr:print"  },
    { path: "/unitqr/generate-from-inward",   component: "GenerateQRFromRegister", permission: "unitqr:create" },
    { path: "/unitqr/generate-from-register", component: "GenerateQRFromRegister", permission: "unitqr:create" },
    { path: "/unitqr/correct",             component: "CorrectUnitQR",           permission: "unitqr:update" },
    { path: "/unitqr/regrade",             component: "RegradeUnitQR",           permission: "unitqr:update" },
    { path: "/unitqr/bulk-regrade",        component: "BulkRegradeUnitQR",       permission: "unitqr:update" },

    // ─── QR STOCK ADJUSTMENT ──────────────────────────────────────────
    { path: "/qrstockadjustment/add",          component: "InputQRStockAdjustment",    permission: "qrstockadjustment:create" },
    { path: "/qrstockadjustment/:id/edit",        component: "InputQRStockAdjustment",    permission: "qrstockadjustment:update" },
    { path: "/qrstockadjustment/details/:id",  component: "QRStockAdjustmentDetail",   permission: "qrstockadjustment:view"   },
    { path: "/qrstockadjustment",              component: "QRStockAdjustments",        permission: "qrstockadjustment:view"   },

    // ─── QR STOCK DEDUCTION (Deduct Stock by Scanning QR Codes) ─────
    { path: "/qrstockdeduction/add",          component: "InputQRStockDeduction",     permission: "qrstockdeduction:create" },
    { path: "/qrstockdeduction/:id/edit",         component: "InputQRStockDeduction",     permission: "qrstockdeduction:update" },
    { path: "/qrstockdeduction/details/:id",  component: "QRStockDeductionDetail",    permission: "qrstockdeduction:view"   },
    { path: "/qrstockdeduction",              component: "QRStockDeductions",         permission: "qrstockdeduction:view"   },

    // ─── QR AUDIT (Catalogue-wise Physical Stock Count) ──────────────
    { path: "/qraudit/add",                   component: "InputQRAudit",              permission: "qraudit:create" },
    { path: "/qraudit/details/:id",           component: "QRAuditDetail",             permission: "qraudit:view"   },
    { path: "/qraudit",                       component: "QRAudits",                  permission: "qraudit:view"   },

    // ─── QR LOCATION AUDIT (Location-wide, no catalogue filter) ─────
    { path: "/qrlocationaudit/add",           component: "InputQRLocationAudit",      permission: "qraudit:create" },

    // ─── QR SCAN TIMER ───────────────────────────────────────────────
    { path: "/qrscantimer/mark-voided",    component: "MarkVoided",                permission: "qrscantimer:update" },
    { path: "/qrscantimer",               component: "ScanTimer",                 permission: "qrscantimer:create" },

    // ─── STOCK REGRADE (Non-QR Grade Reclassification) ───────────────
    { path: "/stockregrade/add",               component: "RegradeStock",              permission: "stockregrade:create" },
    { path: "/stockregrade/details/:id",       component: "StockRegradeDetail",        permission: "stockregrade:view"   },
    { path: "/stockregrade",                   component: "StockRegradeList",          permission: "stockregrade:view"   },


    // ─── QR INTERNAL TRANSFER ─────────────────────────────────────────
    // ── Shop replenishment (godown keeps the shop topped up) ──
    { path: "/replenishment/catalogue/:catalogueno", component: "CatalogueStock",                  permission: "replenishment:view" },
    { path: "/replenishment",                       component: "Replenishment",                    permission: "replenishment:view" },
    { path: "/qrinternaltransfer/bulk-print",       component: "BulkPrintQRInternalTransfer",      permission: "qrinternaltransfer:print"   },
    { path: "/qrinternaltransfer/add",              component: "InputQRInternalTransfer",          permission: "qrinternaltransfer:create" },
    { path: "/qrinternaltransfer/details/:id/print",component: "PrintQRInternalTransfer",          permission: "qrinternaltransfer:print"   },
    { path: "/qrinternaltransfer/details/:id/labels",component: "PrintQRInternalTransferLabels",   permission: "qrinternaltransfer:print"   },
    { path: "/qrinternaltransfer/details/:id",      component: "QRInternalTransferDetail",         permission: "qrinternaltransfer:view"   },
    { path: "/qrinternaltransfer/:id/receive",      component: "ReceiveQRInternalTransfer",        permission: "qrinternaltransfer:receive" },
    { path: "/qrinternaltransfer/:id/edit",         component: "UpdateQRInternalTransfer",         permission: ["qrinternaltransfer:update", "qrinternaltransfer:create"] },
    { path: "/qrinternaltransfer",                  component: "QRInternalTransfers",              permission: "qrinternaltransfer:view"   },

    // ─── QR OUTWARD REGISTER ──────────────────────────────────────────
    { path: "/qroutwardregister/deliveries",       component: "QROutwardRegisterDeliveries",    permission: "qroutwardregister:approve" },
    { path: "/qroutwardregister/delivery-report",   component: "QRDeliveryReport",               permission: "qroutwardregister:view"    },
    { path: "/qroutwardregister/bulk-print",        component: "BulkPrintQROutwardRegister",       permission: "qroutwardregister:print"    },
    { path: "/qroutwardregister/add/from-register", component: "InputQROutwardRegisterFromRegister", permission: "qroutwardregister:create"  },
    { path: "/qroutwardregister/add",               component: "InputQROutwardRegister",           permission: "qroutwardregister:create"  },
    { path: "/qroutwardregister/details/:id/print", component: "PrintQROutwardRegister",           permission: "qroutwardregister:print"    },
    { path: "/qroutwardregister/details/:id/labels",component: "PrintQROutwardRegisterLabels",     permission: "qroutwardregister:print"    },
    { path: "/qroutwardregister/details/:id",       component: "QROutwardRegisterDetail",          permission: "qroutwardregister:view"    },
    { path: "/qroutwardregister/:id/edit",          component: "UpdateQROutwardRegister",          permission: "qroutwardregister:update"  },
    { path: "/qroutwardregister",                   component: "QROutwardRegisters",               permission: "qroutwardregister:view"    },

    // ─── QR MIGRATION ───────────────────────────────────────────────────
    { path: "/qrmigration/add",           component: "InputQRMigration",     permission: "qrmigration:create" },
    { path: "/qrmigration/details/:id",   component: "QRMigrationDetail",    permission: "qrmigration:view"   },
    { path: "/qrmigration",               component: "QRMigrations",         permission: "qrmigration:view"   },

    // ─── QR INWARD REGISTER ───────────────────────────────────────────
    { path: "/qrinwardregister/report",             component: "QRInwardReport",                   permission: "qrinwardregister:view"     },
    { path: "/qrinwardregister/bulk-print",         component: "BulkPrintQRInwardRegister",        permission: "qrinwardregister:print"     },
    { path: "/qrinwardregister/add",                component: "InputQRInwardRegister",            permission: "qrinwardregister:create"   },
    { path: "/qrinwardregister/details/:id/print",  component: "PrintQRInwardRegister",            permission: "qrinwardregister:print"     },
    { path: "/qrinwardregister/details/:id/labels", component: "PrintQRInwardRegisterLabels",      permission: "qrinwardregister:print"     },
    { path: "/qrinwardregister/details/:id",        component: "QRInwardRegisterDetail",           permission: "qrinwardregister:view"     },
    { path: "/qrinwardregister/:id/edit",           component: "UpdateQRInwardRegister",           permission: "qrinwardregister:update"   },
    { path: "/qrinwardregister",                    component: "QRInwardRegisters",                permission: "qrinwardregister:view"     },
    { path: "/unitqr/print-labels/:batchId?", component: "PrintUnitQRLabels",    permission: "unitqr:view"   },
    { path: "/unitqr/generated-qr/:batchId/print", component: "PrintGeneratedQR",  permission: "unitqr:view"   },
    { path: "/unitqr/generated-qr/:batchId", component: "GeneratedQRDetail",     permission: "unitqr:view"   },
    { path: "/unitqr/generated-qr",        component: "GeneratedQRList",         permission: "unitqr:view"   },
    { path: "/unitqr",                    component: "UnitQRList",              permission: "unitqr:view"   },

    // ─── BLOUSE STITCH ────────────────────────────────────────────────
    { path: "/blousestitch/add",              component: "InputBlouseStitch",       permission: "blousestitch:create" },
    { path: "/blousestitch/:id",              component: "BlouseStitchDetail",      permission: "blousestitch:view"   },
    { path: "/blousestitch",                  component: "BlouseStitchList",        permission: "blousestitch:view"   },

    // ─── INWARD FROM DYEING (vendor processing, flat 1:1) ───────────
    { path: "/inwarddyeing/add",              component: "InputVendorProcessing",   permission: "inwarddyeing:create" },
    { path: "/inwarddyeing/:id/edit",         component: "UpdateVendorProcessing",  permission: "inwarddyeing:update" },
    { path: "/inwarddyeing/:id",              component: "VendorProcessingDetail",  permission: "inwarddyeing:view"   },
    { path: "/inwarddyeing",                  component: "VendorProcessingList",    permission: "inwarddyeing:view"   },

    // ─── INWARD FROM STITCHING (recipe-driven) ──────────────────────
    { path: "/inwardstitching/add",           component: "InputStitchingInward",    permission: "inwardstitching:create" },
    { path: "/inwardstitching/:id/edit",      component: "UpdateStitchingInward",   permission: "inwardstitching:update" },
    { path: "/inwardstitching/:id",           component: "StitchingInwardDetail",   permission: "inwardstitching:view"   },
    { path: "/inwardstitching",               component: "StitchingInwardList",     permission: "inwardstitching:view"   },

    // ─── DYEING ─────────────────────────────────────────────────────
    { path: "/dyeing/add",                    component: "InputDyeing",             permission: "dyeing:create" },
    { path: "/dyeing/:id",                    component: "DyeingDetail",            permission: "dyeing:view"   },
    { path: "/dyeing",                        component: "DyeingList",              permission: "dyeing:view"   },

    // ─── INVENTORY DASHBOARD ────────────────────────────────────────
    { path: "/inventory/by-location",         component: "LocationInventory",   permission: "inventory:view" },
    { path: "/inventory/by-design",           component: "DesignInventory",     permission: "inventory:view" },
    { path: "/inventory/by-stage",            component: "StagePipeline",       permission: "inventory:view" },
    { path: "/inventory/at-vendors",          component: "VendorStock",         permission: "inventory:view" },
    { path: "/inventory/production-pipeline", component: "ProductionPipeline",  permission: "inventory:view" },

    // ─── SALES REPORTS (Phase 1) ────────────────────────────────────
    { path: "/salesreports/bill-register", component: "SalesBillRegister", permission: "reports:salesbillregister" },
    { path: "/salesreports/aging",         component: "ReceivablesAging",  permission: "reports:aging",             denyPermission: "reports:restrict_segregation" },
    { path: "/salesreports/outstanding",   component: "OutstandingReport", permission: "reports:aging"             },
    { path: "/salesreports/gst-summary",   component: "GSTSummary",        permission: "reports:gstsummary"        },
    { path: "/salesreports/party-ledger",  component: "PartyLedger",       permission: "reports:partyledger",       denyPermission: "reports:restrict_segregation" },
    { path: "/accountreports/bank-statement", component: "BankStatement",  permission: "firm_accounts:view"        },
    { path: "/banking/reconciliation",        component: "BankReconciliation", permission: "bank:reconcile"         },
    { path: "/accounts/mcs-import",           component: "MCSImport",          permission: "mcsimport:view"         },
    { path: "/banking/cheques",               component: "ChequeRegister",     permission: "cheque:manage"          },
    { path: "/banking/payment-run",           component: "PaymentRun",         permission: "payment_run:create"     },
    { path: "/receivables/reminders",         component: "PaymentReminders",   permission: "reminders:manage"       },
    { path: "/whatsapp/inbox",               component: "WhatsAppInbox",      permission: "whatsapp:send"          },
    { path: "/whatsapp/send-invoices",       component: "SendInvoices",       permission: ["whatsapp:send", "whatsapp:send_document"] },
    { path: "/whatsapp/send-lr",             component: "SendTransportReceipts", permission: ["whatsapp:send", "whatsapp:send_document"] },
    { path: "/receivables/interest",          component: "LateInterest",       permission: ["interest:view", "interest:charge"] },
    { path: "/receivables/commission",        component: "AgentCommission",    permission: ["commission:view", "commission:pay"] },
    { path: "/compliance/tax",                component: "TaxCompliance",      permission: ["tds:view", "tax:configure"] },
    { path: "/salesreports/periodic",      component: "PeriodicSummary",   permission: "reports:periodic"          },

    // ─── SALES REPORTS (Phase 2) ────────────────────────────────────
    { path: "/salesreports/challan-register",   component: "ChallanRegister",     permission: "reports:challanregister"     },
    { path: "/salesreports/order-book",         component: "OrderBook",           permission: "reports:orderbook"           },
    { path: "/salesreports/payment-collection", component: "PaymentCollection",   permission: "reports:paymentcollection"   },
    { path: "/salesreports/agent-performance",  component: "AgentPerformance",    permission: "reports:agentperformance",    denyPermission: "reports:restrict_segregation" },
    { path: "/salesreports/salesman-performance",component: "SalesmanPerformance",permission: "reports:salesmanperformance" },

    // ─── SALES REPORTS (Phase 3) ────────────────────────────────────
    { path: "/salesreports/catalogue-sales", component: "CatalogueWiseSales", permission: "reports:cataloguesales"  },
    { path: "/salesreports/party-catalogue-message", component: "PartyCatalogueMessage", permission: "reports:partycataloguemsg", denyPermission: "reports:restrict_segregation" },
    { path: "/salesreports/firm-comparison", component: "FirmWiseComparison", permission: "reports:firmcomparison"  },
    { path: "/salesreports/fy-summary",      component: "FYSummary",          permission: "reports:fysummary"       },

    // ─── PRODUCTION REPORTS ─────────────────────────────────────
    { path: "/salesreports/production-output", component: "ProductionOutputReport", permission: "reports:productionoutput" },
    { path: "/salesreports/production-report", component: "ProductionReport", permission: "reports:productionreport" },
    { path: "/salesreports/today-production",  component: "TodayProductionReport", permission: "reports:productionreport" },
    { path: "/salesreports/orders-generated",  component: "ProductionOrderReport", permission: "reports:productionreport" },
    { path: "/salesreports/end-of-day",        component: "EndOfDaySummary",   permission: "reports:endofday" },
    { path: "/salesreports/goods-movement",  component: "GoodsMovementReport", permission: "reports:goodsmovement" },
    { path: "/salesreports/cloth-roll-production", component: "ClothRollProductionReport", permission: "reports:clothrollproduction" },

    // ─── GST REPORTS (GSTR-1 / 2 / 3B / 9) ──────────────────────────
    { path: "/gstreports",        component: "GSTReportsHub", permission: "gst:view"  },
    { path: "/gstreports/gstr1",  component: "GSTR1Report",   permission: "gst:gstr1" },
    { path: "/gstreports/gstr2",  component: "GSTR2Report",   permission: "gst:gstr2" },
    { path: "/gstreports/gstr3b", component: "GSTR3BReport",  permission: "gst:gstr3b" },
    { path: "/gstreports/gstr9",  component: "GSTR9Report",   permission: "gst:gstr9" },
    { path: "/gstreports/reconciliation", component: "GSTReconciliation", permission: "gst:reconciliation" },
    { path: "/gstreports/eway-register",  component: "EwayRegister",      permission: "gst:ewaybill" },
    { path: "/gstreports/tds-tcs",        component: "TdsTcsRegister",    permission: "gst:tdstcs" },

    // ─── ACCOUNT / AUDIT REPORTS ────────────────────────────────────
    // Same any-of list as the Nav item, so everyone shown the Hub link can open it.
    { path: "/accountreports",                 component: "AccountReportsHub", permission: ["reports:payablesaging", "reports:supplierledger", "accounts:cashbook", "accounts:daybook", "accounts:receiptregister", "accounts:paymentregister", "accounts:trialbalance", "accounts:pnl", "accounts:balancesheet", "expense:view", "expense:openingbalance", "party_opening_balance:view"] },
    { path: "/accountreports/payables-aging",  component: "PayablesAging",     permission: "reports:payablesaging",  denyPermission: "reports:restrict_segregation" },
    { path: "/accountreports/supplier-ledger", component: "SupplierLedger",    permission: "reports:supplierledger", denyPermission: "reports:restrict_segregation" },
    { path: "/accountreports/cash-book",       component: "CashBook",          permission: "accounts:cashbook"      },
    { path: "/accountreports/day-book",        component: "DayBook",           permission: "accounts:daybook"       },
    { path: "/accountreports/payment-register",component: "PaymentRegister",   permission: "accounts:paymentregister" },
    { path: "/accountreports/receipt-register",component: "ReceiptRegister",   permission: "accounts:receiptregister" },
    { path: "/accountreports/trial-balance",   component: "TrialBalance",      permission: "accounts:trialbalance" },
    { path: "/accountreports/profit-loss",     component: "ProfitLoss",        permission: "accounts:pnl"          },
    { path: "/accountreports/balance-sheet",   component: "BalanceSheet",      permission: "accounts:balancesheet" },
    { path: "/accountreports/cash-flow",       component: "CashFlow",          permission: ["accounts:pnl", "accounts:balancesheet"] },
    { path: "/accountreports/ratios",          component: "Ratios",            permission: ["accounts:pnl", "accounts:balancesheet"] },
    { path: "/accountreports/consolidated",    component: "Consolidated",      permission: "accounts:pnl" },
    { path: "/accountreports/stock-valuation", component: "StockValuation",    permission: ["accounts:balancesheet", "accounts:pnl"] },
    { path: "/accountreports/expenses",        component: "Expenses",          permission: "expense:view"          },
    { path: "/accountreports/opening-balance", component: "OpeningBalance",    permission: "expense:openingbalance" },
    { path: "/accountreports/gl-parity",       component: "GlParity",          permission: "books:gl_parity"       },
    { path: "/admin/jobs",                     component: "ScheduledJobs",     permission: "jobs:manage"           },
    { path: "/admin/analytics",                component: "UsageAnalytics",    permission: "analytics:view"        },
    { path: "/accountreports/party-opening-balance", component: "PartyOpeningBalance", permission: "party_opening_balance:view", denyPermission: "reports:restrict_segregation" },
    { path: "/efficiency-report",              component: "EfficiencyReportList", permission: "efficiencyreport:view" },
    { path: "/efficiency-report/add",          component: "EfficiencyReport",  permission: "efficiencyreport:view" },
    { path: "/efficiency-report/operator-performance", component: "OperatorPerformance", permission: "efficiencyreport:view" },
    { path: "/machine/bulk-loomshade",         component: "BulkLoomShade",     permission: "machine:update"        },
    // Standard work + flow (SOP checklists, defect Pareto, bottleneck board, key-person risk)
    { path: "/sop/templates",                  exact: true, component: "SopTemplates",      permission: ["sop:view", "sop:manage"] },
    { path: "/sop/templates/add",              exact: true, component: "SopTemplateEditor", permission: "sop:manage"            },
    { path: "/sop/templates/update/:id",       exact: true, component: "SopTemplateEditor", permission: "sop:manage"            },
    { path: "/sop/runs",                       exact: true, component: "SopRuns",           permission: "sop:view"              },
    { path: "/defectcode",                     component: "DefectCodes",       permission: ["defectcode:view", "defectcode:manage"] },
    { path: "/defect-pareto",                  component: "DefectPareto",      permission: "defectreport:view"     },
    { path: "/flowboard",                      component: "FlowBoard",         permission: "flowboard:view"        },
    { path: "/admin/key-person",               component: "KeyPersonRisk",     permission: "keyperson:view"        },
    // In-app documentation. Public route: every logged-in user reaches it; the
    // Docs page itself filters articles by the user's permissions.
    { path: "/docs",                           component: "Docs"                                                    },
];

export const finalRoutes = [...routesConfig, ...specialRoutesConfig];

export default finalRoutes;
